export default {
  projectid: "",
  projectname: "projectname",
  datestring: "",
  volumeid: "",
  pouringPosition: ""
}